import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("Page error:", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="page-error-fallback" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "#FFF8F0", color: "#3D2314", fontFamily: "Arial, sans-serif", textAlign: "center" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>Bergen Kaffemaskin- og Teknikk Service</h1>
          <p style={{ marginBottom: 16 }}>Beklager, siden kunne ikke vises akkurat nå. Ring oss gjerne:</p>
          <a href="tel:+4790232206" data-testid="page-error-phone" style={{ fontSize: 24, fontWeight: 700, color: "#3D2314" }}>90 23 22 06</a>
          <p style={{ marginTop: 16 }}><a href="/" data-testid="page-error-reload" style={{ color: "#8B5A2B", textDecoration: "underline" }}>Prøv igjen</a></p>
        </div>
      </div>
    );
  }
}
